import React from 'react';
import {
  TableCell,
  Box,
  Typography,
  Link,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Overlay } from '../../app/feathers/overlays/Overlay';
import { Race } from '../../app/feathers/races/Race';

export interface RaceRowProps {
  overlay: Overlay;
}

export const RaceRow: React.FC<RaceRowProps> = ({ overlay }) => {
  const globalDocument = overlay?.globalDocument as (Race | undefined);
  const overlayDocument = overlay?.overlayDocument as (Race | undefined);

  const raceName = overlay.longName || overlayDocument?.longName || globalDocument?.longName;
  const officeName = overlayDocument?.officeName || globalDocument?.officeName;
  const districtName = overlay.district?.longName || overlayDocument?.district?.longName || globalDocument?.district?.longName;
  const coreDocumentDeleted = (['delete', 'edit'].includes(overlay.overlayType)) && !globalDocument;
  const electionKey = overlayDocument?.election || globalDocument?.election;

  const linkToRace = globalDocument?._id ? `/elections/${electionKey}/races/${globalDocument._id}` : null;

  return (
    <>
      <TableCell>
        {
          coreDocumentDeleted ? (
            <Typography variant="body1">Core Document Deleted</Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {linkToRace ? (
                <Link 
                  href={linkToRace}
                  target="_blank"
                  rel="noopener"
                  sx={{ 
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <Typography variant="body1" fontWeight="bold">{raceName}</Typography>
                  <OpenInNewIcon fontSize="small" />
                </Link>
              ) : (
                <Typography variant="body1" fontWeight="bold">{raceName}</Typography>
              )}
              <Typography variant="body2">{electionKey}</Typography>
            </Box>
          )
        }
      </TableCell>
      <TableCell>
        {
          coreDocumentDeleted ? (
            <Typography variant="body1">Core Document Deleted</Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body1">{officeName}</Typography>
              <Typography variant="body2">{districtName}</Typography>
            </Box>
          )
        }
      </TableCell>
    </>
  );
}; 